<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="8">
        <v-row>
          <!-- create first shop -->
          <v-col cols="12">
            <v-card>
              <v-toolbar color="accent" dark flat dense>
                <v-toolbar-title>Let's get you started</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-row class="subtitle-2 text--primary">
                  <!-- transfer Stock -->
                  <v-col cols="12" xs="12" md="12">
                    <v-radio-group
                      dense
                      label="Is Distributor Version ( supermarket suppliers )"
                      v-model="distributorVersion"
                      row
                    >
                      <v-radio label="Yes" value="Y"></v-radio>
                      <v-radio label="No" value="N"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <!-- end -->
                </v-row>

                <!-- shops version -->
                <v-row dense v-if="distributorVersion == 'N'">
                  <v-col cols="12">
                    <v-btn @click.native="shopDialog = true" text color="primary">
                      <v-icon left dark>mdi-plus</v-icon>New Shop
                    </v-btn>
                  </v-col>

                  <v-col cols="12">
                    <v-alert
                      v-if="shops.length < 1"
                      border="top"
                      colored-border
                      type="info"
                      elevation="2"
                    >Please add at least one shop/store</v-alert>

                    <v-data-table v-else dense :headers="headers" :items="shops" :search="search">
                      <!-- action template -->
                      <template v-slot:item.action="{ item }">
                        <v-btn color="red" @click="deleteRow(item)" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <!-- end -->
                    </v-data-table>
                  </v-col>
                </v-row>
                <!-- end of shops version -->

                <!-- distributor version -->
                <v-row dense v-if="distributorVersion == 'Y'">
                  <v-col cols="12">
                    <v-btn @click.native="companyDialog = true" text color="primary">
                      <v-icon left dark>mdi-plus</v-icon>New Company
                    </v-btn>
                  </v-col>

                  <v-col cols="12">
                    <v-alert
                      v-if="companies.length < 1"
                      border="top"
                      colored-border
                      type="info"
                      elevation="2"
                    >Please add at least one company </v-alert>

                    <v-data-table v-else dense :headers="companyHeaders" :items="companies" :search="search">
                      <!-- action template -->
                      <template v-slot:item.action="{ item }">
                        <v-btn color="red" @click="deleteCompanyRow(item)" icon>
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <!-- end -->
                    </v-data-table>
                  </v-col>
                </v-row>
                <!-- end of distributor version -->

              </v-card-text>
            </v-card>
          </v-col>

          <!-- create first shop -->
          <v-col cols="12">
            <v-card>
              <v-toolbar color="accent" dark flat dense>
                <v-toolbar-title>Default settings (can be changed later)</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-row dense class="subtitle-2 text--primary">
                  <!-- transfer Stock -->
                  <v-col cols="12" xs="12" md="12">
                    <v-radio-group
                      dense
                      label="Accept Stock Transfer Mandatory"
                      v-model="record.AcceptTransfer"
                      row
                    >
                      <v-radio label="Yes" value="Y"></v-radio>
                      <v-radio label="No" value="N"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <!-- end -->

                  <!-- transfer Stock -->
                  <v-col style="margin-top: -35px" cols="12" xs="12" md="12">
                    <v-radio-group
                      dense
                      label="Transfer Insufficient Stock"
                      v-model="record.TransferDeficit"
                      row
                    >
                      <v-radio label="Yes" value="Y"></v-radio>
                      <v-radio label="No" value="N"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <!-- end -->

                  <!-- insufficient -->
                  <v-col style="margin-top: -35px" cols="12" xs="12" md="12">
                    <v-radio-group
                      dense
                      label="Sell Insufficient Stock"
                      v-model="record.SellDeficit"
                      row
                    >
                      <v-radio label="Yes" value="Y"></v-radio>
                      <v-radio label="No" value="N"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <!-- end -->

                  <v-col cols="12">
                    <v-btn
                      class="float-right"
                      color="primary"
                      @click="save"
                      :loading="loader"
                    >Finish</v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          <!-- end -->
        </v-row>
      </v-col>
    </v-row>

    <!-- Ctreate shop dialog -->
    <v-dialog v-model="shopDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create A shop/store</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="shopDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  name="onboardingStoreName"
                  outlined
                  dense
                  label="Store Name"
                  v-model="shopRecord.Name"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-btn color="accent" @click="addShop">
                  <v-icon left>mdi-plus</v-icon>Add To List
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of shop modal-->

    <!-- Create company dialog -->
    <v-dialog v-model="companyDialog" max-width="750px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create A Company</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="companyDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  name="onboardingCompanyName"
                  outlined
                  dense
                  label="Company Name"
                  v-model="companyRecord.Name"
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-btn color="accent" @click="addCompany">
                  <v-icon left>mdi-plus</v-icon>Add To List
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of company modal-->

    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    distributorVersion: "",
    search: "",
    loader: false,
    shopDialog: false,
    companyDialog: false,
    shopRecord: {},
    companyRecord: {},
    record: {},
    headers: [
      { text: "Name", value: "Name" },
      { text: "Action", value: "action" }
    ],
    companyHeaders: [
      { text: "Name", value: "Name" },
      { text: "Action", value: "action" }
    ],
    subscribers: [],
    shops: [],
    companies: [],
  }),
  methods: {
    addShop() {
      const shop = this.shopRecord;
      if (shop.Name == undefined) {
        this.$refs.snackbar.show(
          "Please select an industry and fill shop/store name!",
          "red"
        );
      } else {
        const details = {
          Name: shop.Name,
          LineNum: new Date().getTime()
        };
        const initialArray = [];
        initialArray.push(details);
        this.shops = [...this.shops, ...initialArray];
        this.shopRecord = {};
        this.shopDialog = false;
      }
    },
    addCompany() {
      const shop = this.companyRecord;
      if (shop.Name == undefined) {
        this.$refs.snackbar.show(
          "Please select an icompany name!",
          "red"
        );
      } else {
        const details = {
          Name: shop.Name,
          LineNum: new Date().getTime()
        };
        const initialArray = [];
        initialArray.push(details);
        this.companies = [...this.companies, ...initialArray];
        this.companyRecord = {};
        this.companyDialog = false;
      }
    },
    deleteRow(item) {
      const selectedRow = this.shops.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.shops.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.shops.splice(pos, 1);
    },
    deleteCompanyRow(item) {
      const selectedRow = this.companies.find(record => {
        return record.LineNum === item.LineNum;
      });
      const pos = this.companies.indexOf(selectedRow);
      if (pos === -1) {
        return;
      }
      this.companies.splice(pos, 1);
    },
    save() {
      if (this.distributorVersion == "") {
        this.$refs.snackbar.show("Please set the distributor version to yes or no", "red");
        return;
      }

      if (this.distributorVersion == "N" && this.shops.length < 1) {
        this.$refs.snackbar.show("Please add at least one shop", "red");
        return;
      }

      if (this.distributorVersion == "Y" && this.companies.length < 1) {
        this.$refs.snackbar.show("Please add at least one company", "red");
        return;
      }

      if (
        this.record.AcceptTransfer == undefined ||
        this.record.TransferDeficit == undefined ||
        this.record.SellDeficit == undefined
      ) {
        this.$refs.snackbar.show(
          "Please select all the default settings options!",
          "red"
        );

        return;
      }

      var subscriber_id = localStorage.getItem("subscriber_id");
      const data = this.record;
      data.uomSetup = "N";
      data.subscriber_id = parseInt(subscriber_id);
      data.IsDistributor = this.distributorVersion;
      if(this.distributorVersion == "Y") {
        data.companies = this.companies;

        const shopDetails = {
          Name: "Warehouse",
          LineNum: new Date().getTime()
        };

        var shopsArray = [];
        const initialArray = [];
        initialArray.push(shopDetails);
        shopsArray = initialArray;
        data.shops = shopsArray;
      }

      if(this.distributorVersion == "N") {
      data.shops = this.shops;
      data.companies = [];
      }

      const self = this;
      self.loader = true;
      const url = "/onboarding";
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            localStorage.setItem("IsDistributor", self.distributorVersion);
            if(self.distributorVersion == "Y") {
            self.$router.push("/switch-company");
            }

            if(self.distributorVersion == "N") {
            self.$router.push("/switch-store");
            }
          } else {
            self.loader = false;
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {}
};
</script>